export default __webpack_public_path__ + "static/media/river_sprite_card.0f6f0835.webp";